export default __webpack_public_path__ + "static/media/pause.d9944300.svg";